var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalonHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 820,
    viewBox: "0 0 1440 820",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_168_405",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 820
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 820,
    fill: "#00407A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_168_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1051.9 816.729C1047.87 837.718 1042.88 858.523 1036.16 878.007C1035.61 880.87 1034.11 883.548 1033.56 886.41C986.987 1025.84 888.507 1137.46 764.42 1202.58C682.012 1246.06 587.861 1268.47 490.684 1265.57C462.161 1265.01 432.284 1261.23 403.727 1255.72C280.93 1232.05 174.593 1169 96.6093 1081.73C95.0726 1079.46 92.5839 1077 91.0472 1074.72C1.35474 971.349 -49.5818 835.87 -44.6752 692.359C-44.3421 685.498 -44.0091 678.636 -43.4925 670.82C-42.3098 649.281 -39.2232 628.108 -35.0012 606.166C-26.9243 564.188 -14.2713 524.082 2.95765 485.848C5.19453 479.353 8.19976 473.996 11.3886 467.685C83.5614 318.345 218.765 210.842 376.306 171.958C379.346 171.555 382.569 170.197 385.608 169.794C457.933 153.067 535.303 151.165 613.36 166.216C695.225 182.001 768.842 214.995 832.091 260.831C902.404 310.998 958.759 377.272 998.448 453.195C1054.71 561.007 1076.69 687.934 1051.9 816.729Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1089 845.97L214.152 783.822C214.152 783.822 291.606 904.626 379.087 963.05L318.875 1137.45C318.875 1137.45 215.436 1136.31 115.661 1059.68C116.613 1059.87 57.3946 936.641 54.1089 845.97Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.087 375.083L375.145 224.174L580.011 293.359C580.011 293.359 537.13 444.389 535.383 494.513C535.383 494.513 352.691 525.579 289.587 555.957C289.77 555.003 211.168 460.692 193.087 375.083Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.079 910.523L700.938 680.786L916.913 651.191C916.913 651.191 968.346 748.178 964.438 871.104C964.438 871.104 835.769 1016.48 784.203 1038.19L630.079 910.523Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.448 453.195L957.584 455.209L950.553 455.832C949.785 454.695 949.2 452.603 948.432 451.466C923.525 396.202 844.691 323.615 822.11 302.44C817.901 298.661 815.413 296.202 815.413 296.202L817.283 291.615L830.956 261.601C902.221 311.951 958.575 378.226 998.448 453.195Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.372 1202.77C682.964 1246.24 588.813 1268.66 491.636 1265.75L478.792 1250.41L466.716 1236.21C466.716 1236.21 467.668 1236.39 469.755 1235.8C490.48 1235.84 628.12 1233.69 717.891 1182.73L726.091 1186.29L765.372 1202.77Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.909 305.942L552.875 300.988C555.88 295.631 656.925 252.78 824.898 293.084L823.246 301.67C656.225 261.55 560.892 305.502 559.756 306.273L557.451 302.86L552.909 305.942Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.648 667.96L908.265 665.354C942.552 564.117 950.818 439.064 950.233 436.972L958.984 437.67C959.569 439.762 952.071 565.953 916.648 667.96Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.543 692.968C701.775 691.83 639.919 572.055 504.888 483.685L509.396 475.649C646.147 565.341 709.723 686.437 710.492 687.574L702.543 692.968Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.856 801.215C207.223 799.307 222.682 642 288.349 541.866L296.366 546.38C232.018 644.789 216.926 800.188 216.559 802.096L206.856 801.215Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.095 379.377C205.095 379.377 201.103 379.597 194.658 382.312C167.521 389.942 91.4572 415.842 3.72602 486.986C5.9629 480.491 8.96814 475.134 12.1569 468.823C98.9703 402.45 172.58 379.045 196.493 372.772C200.668 371.598 203.707 371.194 203.707 371.194L205.095 379.377Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.823 240.908L371.072 240.21L372.69 226.67L377.074 173.097C380.114 172.693 383.337 171.336 386.376 170.932L381.808 225.46L379.823 240.908Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5179 853.309L60.2898 860.024C58.5696 858.703 57.0328 856.427 55.4961 854.152C6.64163 800.208 -25.3642 735.66 -43.7233 692.543C-43.3903 685.681 -43.0572 678.82 -42.5406 671.004C-27.4385 710.525 4.81913 784.026 58.4673 843.841C60.7724 847.254 64.0293 850.851 66.5179 853.309Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.247 1050.84L118.7 1059.28L98.5132 1082.1C96.9765 1079.82 94.4879 1077.37 92.9512 1075.09L114.457 1050.54L120.685 1043.83L126.247 1050.84Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.376 1256.58C432.114 1236.46 309.723 1133.71 304.563 1129.74L309.839 1122.85C310.607 1123.98 436.438 1229.38 497.98 1248.17L495.376 1256.58Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.187 968.26L370.887 959.49C372.791 959.857 519.434 967.354 634.036 905.35L638.463 913.129C521.589 976.675 372.091 968.627 370.187 968.26Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.815 1193.19L713.934 1187.9C762.773 1129.05 785.202 1017.61 785.386 1016.65L793.953 1018.31C793.035 1023.08 770.789 1133.56 720.815 1193.19Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.16 878.007C1035.61 880.87 1034.11 883.548 1033.56 886.41L954.185 873.084L955.837 864.498L1036.16 878.007Z",
    fill: "#093067",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_168_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.626 -409C1295.07 -276.294 1884.07 196.589 1524.51 1026.47",
    stroke: "#ADC6DD",
    strokeOpacity: 0.4,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.606 -361.312C1118.71 -182.525 1900.81 366.124 1324.31 1130.42",
    stroke: "#ADC6DD",
    strokeOpacity: 0.4,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.513 -247.182C558.1 -169.666 885.122 1.86963 988.513 67.8832C1117.75 150.4 1568.94 309.004 1047.36 1181.86",
    stroke: "#ADC6DD",
    strokeOpacity: 0.4,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.34 -105.724C452.901 34.3052 1098.83 386.592 1030.05 675.509C961.281 964.425 896.007 1151.68 871.967 1209.19",
    stroke: "#ADC6DD",
    strokeOpacity: 0.4,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-95.0215 105.928C57.8735 193.089 398.512 379.198 537.906 426.351C712.148 485.292 959.665 755.347 668.299 1228.48",
    stroke: "#ADC6DD",
    strokeOpacity: 0.4,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-258.879 376.519C-171.758 437.781 48.6419 566.522 233.27 591.384C464.055 622.462 674.646 833.577 514.25 1309.39",
    stroke: "#ADC6DD",
    strokeOpacity: 0.4,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.29 -259.505C1388.16 -293.083 791.077 -241.608 139.802 232.918C-29.6216 356.362 -181.243 454.682 -314.844 532.46",
    stroke: "#ADC6DD",
    strokeOpacity: 0.4,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1872.42 46.4512C1662.6 64.4906 1158.49 141.935 820.617 307.398C398.281 514.226 -136.563 762.849 -346 869.478",
    stroke: "#ADC6DD",
    strokeOpacity: 0.4,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1933 414.026C1716.64 446.354 1139.22 580.132 560.407 856.617C280.392 990.375 6.46274 1088.31 -224.838 1156.85",
    stroke: "#ADC6DD",
    strokeOpacity: 0.4,
    strokeWidth: 9
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_168_405",
    x: -350.042,
    y: -415.191,
    width: 2285.71,
    height: 1747.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_168_405"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalonHeader);
export default __webpack_public_path__ + "static/media/balon-header.2ef77c0041b2533d30c0e0055c22c83b.svg";
export { ForwardRef as ReactComponent };